import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm, FormControl } from '@angular/forms';
import { MatDialog,MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ShiftWeeks, ShiftWeeksEnum } from '../../../../shared/models/weeks';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { UsersService } from '../../services/users.service';
import { Users } from '../../models/users';
import { CommonService } from 'src/app/shared/services/common.service';
import { ROLES_DATA } from '../../../../shared/constants/roles.constants';
import * as moment from 'moment';
import { delay, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {

  /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
 @ViewChild('myForm', {static: false}) myForm: NgForm;

 @ViewChild('shift_time_starts_at_ref') shift_time_starts_at_ref;

 @ViewChild('shift_time_ends_at_ref') shift_time_ends_at_ref;

  public userForm:FormGroup;
  public shiftWeeks:ShiftWeeksEnum[] = ShiftWeeks;
  public timezones:string[];
  public organizations:Organization[];
  public users:Users;
  public roles:any = ROLES_DATA;
  public hasRole:string = this.authservice.hasRole();
  public orgId:string = this.authservice.getOrgId();
  public btnText:string;
  
  public isShowOrganization:boolean = false;
  public isShowAlert:boolean= false;


  public dropdownSettings:any = {};

  public searchTimezoneCtrl:FormControl =  new FormControl('',Validators.required);

  public filterTimezones:Observable<string[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private fb:FormBuilder,
    private dialog:MatDialog,
    private authservice:AuthenticationService,
    private organizationService:OrganizationAdminService,
    private userService:UsersService,
    private commonService:CommonService) { }

  ngOnInit(): void {
    this.getDropdownSettings();
    this.createUserForm();
      if(this.hasRole == '1'){
      this.isShowOrganization =true;
        this.getOrganizations();
    }

    this.getTimezones();
    if(this.dialogData.user_id != undefined){
      this.btnText ='Update';
      this.getUserById(this.dialogData.user_id);
   }else{
      this.btnText = 'Create';
      this.getUsers(this.orgId);
   }
  }

  getTimezones(){
    this.commonService.getTimezones().subscribe(
      (res:any)=>{
        this.timezones =Object.keys(res);
          this.filterTimezones = this.searchTimezoneCtrl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }
    );
  }

  getOrganizations():void{
    this.organizationService.getOrganizations().subscribe(
      (res:any)=>{
        this.organizations = res.body;
        if(this.organizations && this.organizations.length >0){
          //  this.getUsers(this.organizations[0].org_id);
        }
      }
    );
  }

  organizationChange(event){
    this.getUsers(event.source.value);
    this.userForm.patchValue({
      users: []
    });
  }

  getUsers(orgId:string = undefined):void{

    let filterParams = {};
    
    filterParams["sort"] = "-id";

    if(orgId != undefined){
      filterParams['filter[org_id]'] =orgId;
    }

    this.userService.getUsersList(filterParams).subscribe(
        (res:any)=>{
          this.users = res.body;
          //  console.log(`user details :: `,this.users);
          
        }
      );
  }

  getUserById(id:number |string){
    this.userService.getUserById(id).subscribe(
      (res)=>{
          let data = res.body;

          this.getUsers(data.org_id);

          let role_id = (data.role && data.role.length >0)?data.role[0].role_id:'';

          let reports_to:string[] = (data.reporting_to != null )?data.reporting_to:[];

          let shift_time_starts_at = (data.working_shift != null && data.working_shift.start_at != null)? moment(data.working_shift.start_at, 'H:mm:ss').format('HH:mm') : '';

          let shift_time_ends_at = (data.working_shift != null && data.working_shift.end_at != null) ? moment(data.working_shift.end_at, 'H:mm:ss').format('HH:mm') : '';

          let week_starts_at = (data.working_shift != null)?data.working_shift.week_starts_at: '';
          
          let week_ends_at = (data.working_shift != null)?data.working_shift.week_ends_at: '';

          let timezone = (data.timezone != null)?data.timezone: '';

          this.userForm.patchValue({
            name: data.name ,
            email: data.email ,
            org_id: data.org_id,
            timezone: data.timezone,
            reporting_to: reports_to,
            shift_week_starts: week_starts_at,
            shift_week_ends: week_ends_at,
            shift_time_starts_at: shift_time_starts_at,
            shift_time_ends_at: shift_time_ends_at,
            users: reports_to,
            role_id:role_id
          });

          this.userForm.controls['email'].disable();

          this.searchTimezoneCtrl.setValue(timezone);
          this.searchTimezoneCtrl.updateValueAndValidity();
      }
    )
  }

  createUserForm():void{
    this.userForm = this.fb.group({
      name: ['',[Validators.required]],
      email: ['',[Validators.required,Validators.email]],
      org_id: this.orgId,
      timezone: [''],
      reporting_to: [''],
      shift_week_starts: ['',[Validators.required]],
      shift_week_ends: ['',[Validators.required]],
      shift_time_starts_at: ['',[Validators.required]],
      shift_time_ends_at: ['',[Validators.required]],
      users:[''],
      role_id:['',[Validators.required]]
    });
  }

  get userFormValidate(){
    return this.userForm.controls;
  }

  userFormSubmit():void{
    if(this.userForm.invalid){
      return;
    }

    let userIds =  this.userForm.value.users.map(v => v.id.toString());

    var reportingToJSON = JSON.stringify(userIds);

    this.userForm.patchValue({
      reporting_to: reportingToJSON,
      timezone: this.searchTimezoneCtrl.value,
    });

    if(this.dialogData.user_id != undefined){
      
      this.userForm.addControl('user_id',this.fb.control(this.dialogData.user_id));
      this.userService.updateUser(this.userForm.value).subscribe(
        (res:any)=>{
          // console.log(res);
          this.isShowAlert= true;
          this.closeAlertMessage();
        }
      );

    }else{

      this.userService.createUser(this.userForm.value).subscribe(
        (res)=> {
          
          this.userForm.reset();
          this.myForm.resetForm();
          this.isShowAlert= true;
          this.closeAlertMessage();
          this.createUserForm();
          this.getDropdownSettings();
          this.searchTimezoneCtrl.reset("");
        },
        (err)=>{
         let errorValidation=err.error;
         if((err.status === 422)){
           Object.entries(errorValidation).forEach(([key, value])=>{
            //  console.log(key)
             const formControl = this.userForm.get(key);
              if (formControl) {
                // console.log(formControl);
                // activate the error message
                formControl.setErrors({
                  serverError: value
                });
              }
           })
         }
        }

      );
    }

  
  }

  cancel():void{
    this.dialog.closeAll();
  }

  closeAlertMessage(){
    setTimeout(()=>{
      this.isShowAlert=false;
    },5000);
  }
  
  getDropdownSettings(){

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.timezones.filter(option => option.toLowerCase().includes(filterValue));
  }
}
